module.exports = __webpack_public_path__ + "img/phone-screen-pt.7ddedec4.png";